<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow">
        <div class="accordion-content-block">
            <div class="container" data-aos="fade-in">
                <div class="title">
                    <h2>{{ model.elements.title.value }}</h2>
                </div>
                <div class="subtitle">
                    <p>{{ model.elements.subtitle.value }}</p>
                </div>
                <div class="content" v-if="isReadingMore">
                    <RichText :value="content" />
                </div>
                <div class="read-more">
                    <button class="btn btn-link" @click="readMore">
                        <span class="text">
                            <template v-if="isReadingMore">
                                Read Less
                            </template>
                            <template v-else>
                                Read More
                            </template>
                        </span>
                        <IconChevronDown v-if="!isReadingMore" class="icon" />
                        <IconChevronUp v-else class="icon" />
                    </button>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { contentTypes, type AccordionContentBlockModel } from '~~/app/models';
const type = contentTypes.accordion_content_block;

const props = defineProps<{ model: AccordionContentBlockModel }>();

const isReadingMore = ref(firstOrDefault(props.model.elements.default_state.value)?.codename == 'open')

const readMore = () => {
    isReadingMore.value = !isReadingMore.value
}

const content = computed(() => getLimitedContent(isReadingMore.value, props.model.elements.read_more_character_count.value, props.model.elements.content.value))
</script>